import { unstable_useForkRef as useForkRef } from '@material-ui/utils';
export default useForkRef;